import gql from 'graphql-tag';

/** This schema is for the (deprecated) Experimental GraphQL API and is manually edited. */
export const ExperimentalSchema = gql`
	directive @experimental on QUERY | MUTATION
	directive @SLA on QUERY | MUTATION

	scalar Upload
	scalar JSON

	type Query {
		experimentalAboutConfluence: ExperimentalAboutConfluence
		experimentalTeamCalendars(
			viewingSpaceKey: ID
			include: [String!]
			calendarContext: String!
		): ExperimentalTCSubCalendars
		experimentalTeamCalendarsSearch(
			term: String
			startIndex: Int = 0
			pageSize: Int = 10
			isPopular: Boolean = false
			showSubscriberCount: Boolean = true
			showSubCalendarsInView: Boolean = true
		): ExperimentalTCSubCalendars
		experimentalTeamCalendarsSubscribe(calendarId: ID!): ExperimentalTeamCalendarsSubscribe
		experimentalTeamCalendarEvents(
			subCalendarId: String!
			userTimeZoneId: String!
			start: String!
			end: String!
		): ExperimentalTCEvents
		experimentalTeamCalendarWatchStatus(
			subCalendarIds: [String!]
		): [ExperimentalTCWatchStatusEachCal]
		experimentalTeamCalendarJiraLinksQuery: ExperimentalTCJiraLinks
		experimentalTeamCalendarJiraOptionsQuery(serverId: String!): ExperimentalTCJiraOptions
		experimentalTeamCalendarJiraDateFieldsQuery(
			serverId: String!
			displayField: String
			fieldParam: String!
			queryParam: String
		): [ExperimentalTCDateField!]!
		experimentalTeamCalendarViewPreference: ExperimentalCalendarViewPreference
		experimentalTeamCalendarSubscriberCount(
			calendarId: String!
			calendarContext: String!
			viewingSpaceKey: String
		): ExperimentalTCSubscriberCount
		experimentalTeamCalendarsFormatDate(
			dateTimes: [String!]!
			pattern: String!
		): ExperimentalTCFormatDate
		experimentalTeamCalendarTimezonesQuery: ExperimentalTCTimezones
		experimentalContentDraftDiff(contentId: String!): ExperimentalContentDraftDiff
		experimentalDesPromotionEligibility(
			cloudId: String!
			domain: String!
		): ExperimentalDesPromotionEligibility
		experimentalOpenInvite(cloudId: String!): ExperimentalOpenInvite
		experimentalGenerateSpaceKey(spaceName: String!): ExperimentalGenerateSpaceKey
		experimentalGetCompleteOnboarding(key: String): ExperimentalOnboardingCompletion
		experimentalKeyboardShortcutsStatus: ExperimentalKeyboardShortcutsStatus
		"""
		Fetches macro specific data, stringified
		"""
		experimentalMacroMetadata(
			"""
			The content the macro exists in
			"""
			contentId: ID!
			"""
			The node of the macro to fetch metadata for
			"""
			macroNode: ExperimentalMacroNode!
		): ExperimentalMacroPayload
		experimentalMacroPlaceholderADF(
			contentId: ID!
			macroDefinition: String!
		): ExperimentalMacroPlaceholderResponse
		experimentalPromotedSpaces(
			promotedSpacesLimit: Int = 10
			otherSpacesLimit: Int = 10
			promotedSpaceKey: String = ""
		): ExperimentalPromotedSpaces
		"""
		See also: CCGraphQLSchema : quickReload
		"""
		experimentalQuickReload(contentId: ID!, since: ExperimentalLong!): ExperimentalQuickReload
		experimentalOnboardingTemplate: ExperimentalOnboardingTemplate
		experimentalUserPersonalization(userId: String!): ExperimentalUserPersonalization
		experimentalSitePersonalization(cloudId: String!): ExperimentalSitePersonalization
		experimentalSiteUserPersonalization(
			cloudId: String!
			userId: String!
		): ExperimentalSiteUserPersonalization
		experimentalOnboardingSpaceBlueprints: ExperimentalOnboardingSpaceBlueprints
		experimentalSpace(spaceKey: String!): ExperimentalSpace
		experimentalSpaceProperties(
			spaceKey: String!
			propertyKeys: [String!]!
		): [ExperimentalSpaceProperty]
		experimentalSynchronySnapshot(
			jwt: String
			url: String
			entityId: String
		): ExperimentalSynchronySnapshot
		experimentalSynchronyJwt(contentId: String, draftShareId: String): ExperimentalSynchronyJwt
		experimentalCrossProductAdvancedSearch(
			query: String!
			scope: String
			experimentId: String
			filters: ExperimentalCrossProductSearchFilter
			searchSession: ExperimentalSearchSessionType
			first: Int = 25
			after: String
		): ExperimentalCrossProductSearchResult
		experimentalResolvedInlineComments(contentId: ID!): ExperimentalComments
		experimentalEditorBreadcrumbs(contentId: ID!): ExperimentalEditorBreadcrumbs
		experimentalContentBodyConvert(
			body: String!
			from: String!
			to: String!
			expand: [String]
			spaceKeyContext: String
			contentIdContext: String
			embeddedContentRender: String
		): ExperimentalContentBodyConvertResult
		experimentalLongTask(taskId: ID!): ExperimentalLongTask
		experimentalFetchHaveISeenIt(flagKey: String!): ExperimentalFlagResult
		experimentalIntegrationsInstalled(appKeys: [String!]): ExperimentalIntegrationsInstalled
		experimentalCurrentUser: ExperimentalCurrentUser
		experimentalSystemInfoSettings: ExperimentalSystemInfoSettings
		experimentalDefaultLogoForSpace(spaceKey: String!): ExperimentalDefaultLogoForSpace
		experimentalThemeSpaceHomeOverride(
			themeAddonKey: String
			themeModuleKey: String
			spaceKey: String!
			spaceHomePageId: String!
		): ExperimentalThemeSpaceHomeOverride
		experimentalRelationsForContent(
			relationName: String!
			sourceType: String!
			targetKey: String!
			targetStatus: String!
		): ExperimentalRelationsForContent
		experimentalMarketplaceApps(
			application: String!
			text: String
			offset: Int
			limit: Int
			isSiteAdmin: Boolean!
		): [ExperimentalMarketplaceApp!]
		experimentalConnectServlet(
			addonKey: String!
			moduleKey: String!
		): ExperimentalConnectServletResponse
		experimentalNotifications(first: Int!, cursor: String): ExperimentalNotificationsResponse!
		experimentalConnectContext(
			addonKey: String!
			moduleKey: String!
			spaceId: String
			spaceKey: String
			contentId: String
			contentType: String
			contentVersion: Int
			contentPlugin: String
		): ExperimentalConnectContext
		experimentalCustomContentConnectModules: ExperimentalConnectModule!
		experimentalCustomContentPage(
			contentId: String
			contentType: String
			orderBy: String
			start: Int
			limit: Int
		): ExperimentalCustomContentPageResponse
		experimentalCustomContentProperties(
			contentId: String
		): ExperimentalCustomContentPropertiesResponse
		experimentalCustomContentPropertiesPage(
			contentId: String
			contentType: String
			orderBy: String
			start: Int
			limit: Int
		): ExperimentalCustomContentPropertiesPageResponse
		experimentalUnlicensedPermission(spaceKey: String!): ExperimentalUnlicensedPermissionResponse
		experimentalGetAutomationRuleById(
			cloudId: String!
			spaceId: String
			automationStack: String!
			ruleId: String!
		): ExperimentalGetAutomationRuleByIdResponse
		experimentalAutomationRuleConnections(
			cloudId: String!
			spaceId: String
			automationStack: String!
			ruleId: String!
		): [ExperimentalAutomationRuleConnectionsResponse]
		experimentalAutomationRuleSummary(
			ruleId: String!
			cloudId: String!
			automationStack: String!
			spaceId: String!
		): ExperimentalAutomationRuleSummaryResponse
		experimentalAnalyticsActivityByUser(
			cloudId: String!
			fromDate: String!
			toDate: String!
			timezone: String!
			content: String!
			spaceId: String
			spaceType: String
			sortorder: String
			sortBy: String
			offset: Int
			limit: Int
		): ExperimentalAnalyticsActivityByUserResponse
		experimentalAnalyticsViewsByDate(
			cloudId: String!
			contentId: String!
			contentType: String!
			fromDate: String!
			toDate: String!
			type: String!
			period: String!
			timezone: String!
		): ExperimentalAnalyticsViewsByDateResponse
		experimentalAnalyticsContentViews(
			cloudId: String!
			spaceId: String!
			fromDate: String!
			toDate: String!
			timezone: String!
			content: String!
			sortorder: String
			sortBy: String
			offset: Int
			limit: Int
		): ExperimentalAnalyticsContentViewsResponse
		experimentalAnalyticsActivityBySpace(
			cloudId: String!
			fromDate: String!
			toDate: String!
			spaceType: String!
			timezone: String!
			content: String!
			sortOrder: String
			sortBy: String
			offset: Int
			limit: Int
		): ExperimentalAnalyticsActivityBySpaceResponse
		experimentalAnalyticsActivityByDate(
			cloudId: String!
			entity: String!
			fromDate: String!
			toDate: String!
			spaceType: String
			timezone: String!
			content: String!
			period: String!
			aggregation: String
			stats: [String]
			spaceKey: String
			spaceId: String
			spaceDataType: String
		): ExperimentalAnalyticsActivityByDateResponse
		experimentalAnalyticsUniqueSearchTermCount(
			cloudId: String!
			fromDate: String!
			toDate: String!
			timezone: String!
			period: String!
			searchFilter: String
		): ExperimentalAnalyticsUniqueSearchTermCountResponse
		experimentalAnalyticsSearchCountGroupByPage(
			cloudId: String!
			fromDate: String!
			toDate: String!
			limit: String!
			searchTerm: String!
			sortOrder: String!
		): ExperimentalAnalyticsSearchCountGroupByPageResponse
		experimentalAnalyticsSearchCountGroupBySpace(
			cloudId: String!
			fromDate: String!
			toDate: String!
			limit: String!
			searchTerm: String!
			sortOrder: String!
		): ExperimentalAnalyticsSearchCountGroupBySpaceResponse
		experimentalAnalyticsViewsByCurrentUser(
			cloudId: String!
			contentId: String!
		): ExperimentalAnalyticsViewsByCurrentUserResponse
		experimentalAnalyticsSearchTimeseriesCTR(
			cloudId: String!
			fromDate: String!
			toDate: String!
			timezone: String!
			granularity: String!
			searchTerm: String!
			sortOrder: String!
		): ExperimentalAnalyticsSearchTimeseriesCTRResponse
		experimentalAnalyticsSearchTimeseriesCount(
			cloudId: String!
			fromDate: String!
			toDate: String!
			timezone: String!
			granularity: String!
			searchTerm: String!
			sortOrder: String!
		): ExperimentalAnalyticsSearchTimeseriesCountResponse
		experimentalAnalyticsSpaceContentViewExport(
			cloudId: String!
			fromDate: String!
			toDate: String!
			spaceId: String!
			spaceKey: String!
			timezone: String!
			content: String!
			period: String!
		): ExperimentalSpaceContentViewExportResponse
		experimentalAnalyticsExportCsvStatus(
			cloudId: String!
			jobId: String!
			spaceId: String!
			spaceKey: String!
		): ExperimentalExportStatusResponse
		experimentalAutomationUsage(
			cloudId: String!
			automationStack: String!
			spaceId: String
		): [ExperimentalAutomationUsageResponse]
		experimentalAnalyticsRestrictionsBySpace(
			cloudId: String!
			spaceKey: String!
			spaceId: String!
		): ExperimentalAnalyticsRestrictionsBySpaceResponse
	}

	enum NotificationActionEnum {
		NOTIFY
		DONT_NOTIFY
	}

	input MentionOptions {
		notificationAction: NotificationActionEnum!
	}

	type Mutation {
		experimentalAddPersonalSpaceLink(spaceUserKey: String!): Boolean
		experimentalAddCustomizedPersonalSpace(
			spaceName: String!
		): ExperimentalAddCustomizedPersonalSpaceResult
		experimentalAddSpaceLink(id: String!, spaceKey: String!): Boolean
		experimentalCopyPageTree(
			contentId: String!
			destinationPageId: String!
			copyLabels: Boolean!
			copyPermissions: Boolean!
			copyDescendants: Boolean!
			prefix: String!
			search: String!
			replace: String!
			mentionOptions: MentionOptions!
		): ExperimentalCopyPageTreeResponse
		experimentalCreateDemoSpace(spaceKey: String!, spaceName: String!): ExperimentalDemoSpace
		experimentalCreateSpecificSpace(
			spaceKey: String!
			spaceName: String!
			spaceBlueprintId: String!
			hasDraft: Boolean
		): ExperimentalOnboardingSpace
		experimentalDeleteComment(contentId: ID!): ExperimentalDeleteComment
		experimentalDeleteContentVersion(contentId: String!, versionNumber: Int!): Boolean
		experimentalDisableKeyboardShortcuts: ExperimentalKeyboardShortcutsStatus
		experimentalEnableKeyboardShortcuts: ExperimentalKeyboardShortcutsStatus
		experimentalGrantAccess(
			contentId: String!
			accessType: String!
			accountId: String!
		): ExperimentalGrantAccess
		experimentalCreateBlankFabricPage(
			spaceKey: String!
			parentPage: String
			title: String
			isSpaceAliasFFEnabled: Boolean
		): ExperimentalCreateContentResponse
		experimentalUpdateContentProperty(
			contentId: String!
			propertyKey: String!
			propertyValue: String
			versionNumber: String
			isDelete: Boolean
		): ExperimentalUpdateContentProperty
		experimentalCreateFabricBlogpost(
			spaceKey: String!
			title: String
			returnSpaUrl: Boolean
			isSpaceAliasFFEnabled: Boolean
		): ExperimentalCreateContentResponse
		experimentalPublishPageByBlueprint(
			spaceKey: String!
			contentId: String
			blueprint: String!
			title: String
			attemptSpaUrlResponse: Boolean
		): ExperimentalPublishContentLink
		experimentalPublishPageByTemplate(
			spaceKey: String!
			contentId: String
			blueprint: String
			context: String
			title: String
			attemptSpaUrlResponse: Boolean
		): ExperimentalPublishContentLink
		experimentalUpdateDraftWithBlueprint(
			contentId: String!
			spaceKey: String!
			blueprint: String!
			parentPageId: String
			title: String
		): ExperimentalUpdateInstanceResponse
		experimentalUpdateDraftWithTemplate(
			contentId: String!
			spaceKey: String!
			blueprint: String!
			context: String
			title: String
			parentPageId: String
		): ExperimentalUpdateInstanceResponse
		experimentalRemoveSpaceLink(id: String!, spaceKey: String!): Boolean
		experimentalRequestAccess(contentId: String!, accessType: String!): ExperimentalRequestAccess
		experimentalRestoreContentVersion(
			contentId: String!
			versionNumber: Int!
			message: String
		): ExperimentalContentVersionRestored
		experimentalSaveFabricComment(params: ExperimentalFabricCommentInput): ExperimentalFabricComment
		experimentalSetFeatureDiscovered(
			pluginKey: String!
			featureKey: String!
		): ExperimentalDiscoveredFeature
		experimentalSubmitFeedbackCollector(
			summary: String!
			component: String!
			description: String
		): ExperimentalJiraIssue
		experimentalFavouriteSpace(spaceKey: String!): ExperimentalFavouriteSpaceType
		experimentalUnfavouriteSpace(spaceKey: String!): ExperimentalFavouriteSpaceType
		experimentalUpdateDesSettings(
			cloudId: String!
			settings: ExperimentalDesSettingsInput
		): ExperimentalDesSettings
		experimentalUpdateOpenInviteSettings(
			cloudId: String!
			settings: ExperimentalOpenInviteSettingsInput
		): ExperimentalOpenInviteSettings
		experimentalUpdateShortcutLinks(
			spaceKey: String!
			quickLinks: [ExperimentalSpaceSidebarLink]
		): ExperimentalQuickLinks
		experimentalUpdateSiteSignUpSettings(
			cloudId: String!
			settings: ExperimentalSiteSignUpSettingsInput
		): ExperimentalSiteSignUpSettings
		experimentalUpdateSpaceLogo(
			spaceKey: String!
			spaceName: String!
			logoDataURI: String!
		): ExperimentalSpaceLogo
		experimentalFileUpload(
			size: Int!
			contentType: String!
			mimeType: String!
			fileName: String!
			pageId: String!
			fileStoreId: String!
			minorEdit: Boolean
			renderEditorHTML: Boolean
			collectionName: String!
			uploadSource: String
		): Boolean
		experimentalMigratePages(contentId: ID!, contentHash: String!): ExperimentalMigratePages
		experimentalMigrateTemplate(templateId: ID!): ExperimentalMigrateTemplate
		experimentalArchiveSpace(
			spaceKey: String!
			spaceName: String!
			description: String
			homePageTitle: String!
			archived: Boolean!
		): ExperimentalArchiveSpace
		experimentalSetHaveISeenIt(flagKey: String!): Boolean
		experimentalTeamCalendar_Hide(calendarIds: [String!], action: String!): Boolean
		experimentalTeamCalendar_Watch(calendarId: String!, action: String!): Boolean
		experimentalTeamCalendar_EventType_Disable(
			calendarId: String!
			disableEventTypes: [String!]
		): ExperimentalTCEventTypeDisableResponse
		experimentalTeamCalendarEventTypeDefaultUpdate(
			title: String!
			icon: String!
			subCalendarId: String!
			eventTypeId: String!
			periodInMins: Int!
			created: String
		): ExperimentalTCEventTypeDefaultUpdateResponse
		experimentalTeamCalendarEventTypeCustomUpdate(
			title: String!
			icon: String!
			subCalendarId: String!
			customEventTypeId: String!
			periodInMins: Int!
			created: String
		): ExperimentalTCEventTypeCustomUpdateResponse
		experimentalTeamCalendarEventTypeCustomDelete(
			subCalendarId: String!
			customEventTypeId: String!
		): ExperimentalTCEventTypeCustomDeleteResponse
		experimentalTeamCalendarDeleteEvent(
			subCalendarId: String!
			uid: String!
		): ExperimentalTeamCalendarDeleteEventResponse
		experimentalTeamCalendarDelete(
			subCalendarId: String!
			calendarContext: String!
			viewingSpaceKey: String
		): ExperimentalTCSubCalendars
		experimentalTeamCalendarDeleteSingleEvent(
			subCalendarId: String!
			uid: String!
			originalStart: String
			singleInstance: Boolean
			recurUntil: String
			recurrenceId: String
		): ExperimentalTeamCalendarDeleteEventResponse
		experimentalTeamCalendarDeleteAllFutureEvents(
			subCalendarId: String!
			uid: String!
			recurUntil: String
		): ExperimentalTeamCalendarDeleteEventResponse
		experimentalTeamCalendarPreferences(
			subCalendarId: String!
			calendarContext: String!
			viewingSpaceKey: String
		): ExperimentalTCSubCalendars
		experimentalTeamCalendarResetSubscribeLink(subCalendarId: String!): Boolean
		experimentalTeamCalendarsAddEvent(
			allDayEvent: Boolean
			childSubCalendarId: String
			customEventTypeId: String
			description: String
			editAllInRecurrenceSeries: Boolean
			endDate: String
			endTime: String
			eventType: String
			originalCustomEventTypeId: String
			originalEventType: String
			originalStartDate: String
			originalSubCalendarId: String
			recurrenceId: String
			rruleStr: String
			startDate: String
			startTime: String
			subCalendarId: String
			uid: String
			url: String
			userTimeZoneId: String
			what: String
			where: String
			persons: [ExperimentalTeamCalendarsAddEventPerson]
		): ExperimentalTeamCalendarsAddEventResponse
		experimentalTeamCalendarEdit(
			type: String!
			parentId: String
			subCalendarId: String
			name: String
			description: String
			color: String
			spaceKey: String
			timeZoneId: String
			calendarContext: String
			viewingSpaceKey: String
			location: String
			username: String
			password: String
		): ExperimentalTeamCalendarEditResponse
		experimentalTeamCalendarSubscribe(
			color: String!
			watchSubCalendars: Boolean!
			subCalendarIds: [String!]!
			calendarContext: String!
			viewingSpaceKey: String
		): ExperimentalTCSubCalendars
		experimentalTeamCalendarImport(
			calendarId: String
			decorator: String
			color: String
			spaceKey: String
			name: String
			description: String
			spaceKeyAutocomplete: String
			file_0: Upload!
			timeZoneId: String
		): ExperimentalTeamCalendarImportResponse
		experimentalTeamCalendarUpdateViewPreference(view: String!): Boolean!
		experimentalTeamCalendarJiraJQLValidate(
			serverId: String!
			jql: String!
		): ExperimentalTeamCalendarJiraJQLValidateResponse
		experimentalDraftSync(
			contentId: ID!
			contentType: String!
			content: String!
			ncsStepVersion: String!
			title: String
		): ExperimentalContent
		experimentalTeamCalendarColors(
			subCalendarId: String!
			color: String!
			calendarContext: String!
			viewingSpaceKey: String!
		): ExperimentalTeamCalendarColorsResponse
		experimentalTeamCalendarReminders(
			subCalendarId: String!
			isReminder: Boolean!
		): ExperimentalTeamCalendarRemindersResponse
		experimentalTeamCalendarRestriction(
			subCalendarId: String!
			calendarContext: String!
			viewingSpaceKey: String!
			updateUsersPermittedToView: Boolean!
			updateGroupsPermittedToView: Boolean!
			updateUsersPermittedToEdit: Boolean!
			updateGroupsPermittedToEdit: Boolean
			usersPermittedToView: [String!]
			usersPermittedToEdit: [String!]
			groupsPermittedToView: [String!]
			groupsPermittedToEdit: [String!]
		): ExperimentalTeamCalendarRestrictionResponse
		experimentalPublishEditorContent(
			contentId: ID!
			contentType: String!
			content: String!
			message: String
			spaceKey: String!
			suppressNotifyWatchers: Boolean
			ncsStepVersion: String
			title: String!
			version: Int!
			schedulePublishDate: String
			ancestors: [Ancestor]
			restrictions: ContentRestrictionsObj
			moveRequest: MoveRequestObj
			isBlueprintCreate: Boolean
		): ExperimentalPublishEditorContentResponse
		experimentalPublishPageAsBlog(
			contentId: String!
			destinationType: String!
			sourceStatus: String!
			destinationSpaceKey: String
			content: String
			title: String
			syncRev: String
			ncsStepVersion: String
			message: String
			suppressNotifyWatchers: Boolean
			schedulePublishDate: String
			restrictions: ContentRestrictionsObj
		): ExperimentalPublishPageAsBlog
		experimentalRevertContent(contentId: ID!): Boolean
		experimentalResetCollabService(
			contentId: String!
			traceId: String
			behind: String
		): ExperimentalResetCollabServiceResponse
		experimentalCancelScheduledPublish(contentId: ID!): ExperimentalCancelScheduledPublishResponse
		experimentalEditorStartHeartbeat(
			contentId: ID!
			contentType: String
			collabService: String!
			heartbeatUserType: ExperimentalHeartbeatUserType
		): ExperimentalEditorHeartbeatResponse
		experimentalEditorStopHeartbeat(
			contentId: ID!
			contentType: String
			heartbeatUserType: ExperimentalHeartbeatUserType
		): Boolean
		experimentalShare(requestBody: ExperimentalShareRequestBodyType!): ExperimentalShareResponse
		experimentalRemoveUnlicensedPermission(
			spaceKey: String!
			permissionId: Int!
		): ExperimentalRemoveUnlicensedPermissionResponse
		experimentalCreateAutomationRuleFromTemplate(
			templateId: String!
			cloudId: String!
			automationStack: String!
			spaceId: String
			parameters: [ExperimentalCreateAutomationRuleFromTemplateParameter!]
		): ExperimentalCreateAutomationRuleFromTemplateResponse
		experimentalUpdateAutomationRule(
			cloudId: String!
			spaceId: String
			automationStack: String!
			ruleId: String!
			body: ExperimentalUpdateAutomationRuleConfigBean!
		): ExperimentalUpdateAutomationRuleResponse
		experimentalUpdateAutomationRuleWithConnection(
			cloudId: String!
			spaceId: String
			automationStack: String!
			ruleId: String!
			ruleConfig: ExperimentalUpdateAutomationRuleConfigBean!
			connections: [ExperimentalConnectionConfig!]
		): ExperimentalUpdateAutomationRuleConnectionResponse
		experimentalAnalyticsSetRestrictionsBySpace(
			cloudId: String!
			spaceKey: String!
			spaceId: String!
			restrictions: [ExperimentalAnalyticsRestrictionsUserGroupInput]
		): ExperimentalAnalyticsSetRestrictionsBySpaceResponse
		experimentalAnalyticsSetSiteRestrictions(
			cloudId: String!
			restrictions: [ExperimentalAnalyticsRestrictionsGroupInput]
		): ExperimentalAnalyticsSetSiteRestrictionsResponse
	}

	input ExperimentalConnectionConfig {
		id: String!
		connectionTargetKey: String!
		accountId: String!
		targetConfigJson: String!
		authType: String!
		authUserSource: String!
		container: ExperimentalConnectionContainerInput!
		createdAt: String!
		updatedAt: String!
	}

	input ExperimentalConnectionContainerInput {
		id: String!
		type: String!
	}

	type ExperimentalUpdateAutomationRuleConnectionResponse {
		id: ExperimentalLong!
		state: ExperimentalAutomationRuleState!
	}

	type ExperimentalAutomationUsageResponse {
		ruleId: String!
		executionCount: String!
	}

	input Ancestor {
		id: String
	}

	input ProfilePicture {
		path: String
	}

	input RESTUser {
		type: String
		accountId: String
		publicName: String
		profilePicture: ProfilePicture
		displayName: String
		hasSpaceViewPermission: Boolean
		hasSpaceEditPermission: Boolean
		isExternalCollaborator: Boolean
	}

	input RESTGroup {
		type: String
		name: String
		id: String
	}

	input UserRestrictions {
		results: [RESTUser]
	}

	input GroupRestrictions {
		results: [RESTGroup]
	}

	input UserAndGroupRestrictions {
		user: UserRestrictions
		group: GroupRestrictions
	}

	input ContentRestrictionObj {
		operation: String
		restrictions: UserAndGroupRestrictions
	}

	input ContentRestrictionsObj {
		administer: ContentRestrictionObj
		copy: ContentRestrictionObj
		create: ContentRestrictionObj
		delete: ContentRestrictionObj
		export: ContentRestrictionObj
		move: ContentRestrictionObj
		purge: ContentRestrictionObj
		purge_version: ContentRestrictionObj
		read: ContentRestrictionObj
		restore: ContentRestrictionObj
		update: ContentRestrictionObj
		use: ContentRestrictionObj
	}

	input MoveRequestObj {
		targetId: String
		position: String
	}

	type ExperimentalPublishEditorContentResponseSpace {
		name: String
	}

	type ExperimentalPublishEditorContentResponse {
		success: Boolean
		status: Int
		createdDate: String
		message: String
		traceId: String
		space: ExperimentalPublishEditorContentResponseSpace
	}

	type ExperimentalTeamCalendarRestrictionResponse {
		success: Boolean
	}

	type ExperimentalTeamCalendarJiraJQLValidateResponse {
		valid: Boolean!
	}

	type ExperimentalTeamCalendarColorsResponse {
		modifiedSubCalendarId: String
		payload: [ExperimentalTCDecoratedSubCalendar]
		success: Boolean
	}
	type ExperimentalTeamCalendarRemindersResponse {
		for_user: String
		on_calendar: String
		reminder_status: Boolean
		success: Boolean
	}

	type ExperimentalTeamCalendarsResetSubscribeLinkResponse {
		success: Boolean!
	}

	type ExperimentalTeamCalendarDeleteEventResponse {
		success: Boolean!
	}

	input ExperimentalTeamCalendarsAddEventPerson {
		person: String
	}

	type ExperimentalContentBodyConvertResult {
		value: String
	}

	type ExperimentalMigratePages {
		status: String
	}

	type ExperimentalMigrateTemplate {
		success: Boolean
	}

	type ExperimentalPublishPageAsBlog {
		id: ID
		_links: ExperimentalPublishPageAsBlogLinks
		status: String
	}

	type ExperimentalPublishPageAsBlogLinks {
		webui: String
		editui: String
	}

	type ExperimentalContent {
		ancestors: [ExperimentalContent]
		body: ExperimentalContentBodyPerRepresentation
		container: ExperimentalSpaceOrContent
		history: ExperimentalHistory
		id: ID
		links: ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase
		operations: [ExperimentalOperationCheckResult]
		status: String
		title: String
		type: String
		version: ExperimentalVersion
	}

	type ExperimentalContentBody {
		content: ExperimentalContent
		macroRenderedOutput: ExperimentalFormattedBody
		links: ExperimentalLinksContextBase
		representation: String
		value: String
		webresource: ExperimentalWebResourceDependencies
	}

	type ExperimentalContentBodyPerRepresentation {
		editor: ExperimentalContentBody
		view: ExperimentalContentBody
	}

	type ExperimentalCurrentUser {
		timeZone: String
	}

	type ExperimentalSystemInfoSettings {
		baseUrl: String
		fallbackBaseUrl: String
		defaultTimeZone: String
	}

	type ExperimentalDefaultLogoForSpace {
		logoDownloadPath: String
	}

	type ExperimentalMarketplaceAppRating {
		averageStars: Float!
		count: Int!
	}

	type ExperimentalMarketplaceApp {
		key: String!
		name: String!
		logoUrl: String
		tagLine: String
		ratings: ExperimentalMarketplaceAppRating!
		listingUrl: String
	}

	type ExperimentalDeleteComment {
		statusCode: String
		contentId: ID
	}

	type ExperimentalAboutConfluence {
		html: String!
	}

	type ExperimentalApplication {
		applicationType: String
		id: ID
		key: String
		label: String
		link: String
		local: Boolean
		self: Boolean
	}

	type ExperimentalApplicationList {
		linkedApplications: [ExperimentalApplication]
	}

	type ExperimentalTeamCalendarsSubscribe {
		url: String
	}

	type ExperimentalTCSubCalendars {
		payload: [ExperimentalTCDecoratedSubCalendar!]
		success: Boolean!
	}

	type ExperimentalTCDecoratedSubCalendar {
		administrable: Boolean!
		childSubCalendars: [ExperimentalTCDecoratedSubCalendar!]
		editable: Boolean!
		deletable: Boolean!
		eventsEditable: Boolean!
		eventsHidden: Boolean!
		groupsPermittedToEdit: [String]
		groupsPermittedToView: [String]
		reminderMe: Boolean
		subCalendar: ExperimentalTCSubCalendar!
		subscriberCount: Int
		usersPermittedToEdit: [ExperimentalTCUser]
		usersPermittedToView: [ExperimentalTCUser]
	}

	type ExperimentalTCUser {
		avatarUrl: String
		fullName: String
		id: String
	}

	type ExperimentalTCSubCalendar {
		applicationId: String
		applicationName: String
		color: String
		customEventTypes: [ExperimentalTCCustomEventType]
		dateFieldNames: [String!]
		description: String
		disableEventTypes: [String]
		durations: [ExperimentalTCJiraCalendarDurations!]
		id: String
		jql: String
		name: String
		parentId: String
		sanboxEventTypeReminders: [ExperimentalTCEventTypeReminder]
		searchFilterId: Int
		sourceLocation: String
		spaceKey: String
		spaceName: String
		subscriptionId: String
		subscriptionType: String
		timeZoneId: String
		type: String
	}

	type ExperimentalTCEventTypeReminder {
		eventTypeId: String
		periodInMins: Int
		isCustomEventType: Boolean
	}

	type ExperimentalTCCustomEventType {
		created: String
		icon: String
		periodInMins: Int
		customEventTypeId: String
		title: String
		parentSubCalendarId: String
	}

	type ExperimentalTCJiraCalendarDurations {
		startDateFieldName: String!
		endDateFieldName: String!
	}

	type ExperimentalTCEvents {
		success: Boolean!
		events: [ExperimentalTCEvent]
	}

	type ExperimentalTCEventExtraProperties {
		assigneeName: String
		assigneeProfileUrl: String
		dateField: String
		issueLink: String
		jiraIssueDisplayDayDuration: String!
		jiraVersionDisplayDayDuration: String!
		releaseNotesLink: String
		resolved: String!
		statusText: String
		summaryLink: String
		viewIssuesLink: String
		viewBoardsUrl: String
	}

	type ExperimentalTCEventInvitees {
		displayName: String!
		id: String!
		avatarIconUrl: String!
	}

	type ExperimentalTCEventRecur {
		freq: String
		byDay: String
		interval: String
		until: String
	}

	type ExperimentalTCEvent {
		allDay: Boolean
		backgroundColor: String
		borderColor: String
		calendarReloadRequiredOnUpdate: Boolean
		className: String
		colorScheme: String
		confluenceFormattedStartDate: String
		customEventTypeId: String
		description: String
		editable: Boolean
		end: String!
		eventType: String!
		expandDates: Boolean
		extraProperties: ExperimentalTCEventExtraProperties
		extraPropertiesTemplate: String
		iconLink: String
		iconUrl: String
		id: String!
		invitees: [ExperimentalTCEventInvitees!]
		localizedEndDate: String
		localizedEndTime: String
		localizedOriginalEndDate: String
		localizedOriginalStartDate: String
		localizedStartDate: String
		localizedStartTime: String
		mediumIconUrl: String
		originalEndDateTime: String!
		originalEndTime: String
		originalStart: String
		originalStartDateTime: String!
		originalStartTime: String
		recur: ExperimentalTCEventRecur
		recurId: String
		rruleStr: String
		secondaryBorderColor: String
		shortTitle: String
		start: String!
		subCalendarId: String!
		textColor: String
		title: String
		urlAlias: String
		workingUrl: String
		where: String
	}

	type ExperimentalTCJiraEventProps {
		jiraVersionDisplayDayDuration: String
		assigneeName: String
		statusText: String
		assigneeProfileUrl: String
		dateField: String
		issueLink: String
		jiraIssueDisplayDayDuration: String
		resolved: String
		viewBoardsUrl: String
		summaryLink: String
		viewIssuesLink: String
		releaseNotesLink: String
	}

	type ExperimentalTCEventTypeDisableResponse {
		modifiedSubCalendarId: String
		payload: [ExperimentalTCDecoratedSubCalendar]
		success: Boolean
	}

	type ExperimentalTCEventTypeDefaultUpdateResponse {
		success: Boolean
	}

	type ExperimentalTCEventTypeCustomUpdateResponse {
		created: String!
		icon: String!
		periodInMins: Int!
		customEventTypeId: String!
		title: String!
		parentSubCalendarId: String!
	}

	type ExperimentalTCEventTypeCustomDeleteResponse {
		success: Boolean
	}

	type ExperimentalTCFieldError {
		field: String!
		errorMessages: [String!]!
	}

	type ExperimentalTeamCalendarsAddEventResponse {
		success: Boolean!
		event: ExperimentalTCEvent
		subCalendar: ExperimentalTCDecoratedSubCalendar
		fieldErrors: [ExperimentalTCFieldError]
	}

	type ExperimentalTeamCalendarEditResponse {
		success: Boolean
		modifiedSubCalendarId: String
		payload: [ExperimentalTCDecoratedSubCalendar]
		fieldErrors: [ExperimentalTCFieldError]
	}

	type ExperimentalTeamCalendarImportResponse {
		success: Boolean!
		subCalendarId: String
		fieldErrors: [ExperimentalTCFieldError!]
	}

	type ExperimentalTCWatchStatusEachCal {
		watched: Boolean
		isWatchable: Boolean
		watchedViaContent: Boolean
		subCalendarId: String
	}

	type ExperimentalTCWatchStatus {
		payload: [ExperimentalTCWatchStatusEachCal]
	}

	type ExperimentalTCFormatDate {
		dates: [String]
	}

	type ExperimentalTCDateField {
		customfield: Boolean!
		name: String!
		key: String!
	}

	type ExperimentalCalendarViewPreference {
		view: String!
		subCalendarsInView: [String]
	}

	type ExperimentalTCSubscriberCount {
		subscriptionCount: Int!
	}

	type ExperimentalTCJiraOptions {
		projects: [ExperimentalTCJiraOption!]
		searchRequests: [ExperimentalTCJiraSearchRequest!]
	}

	type ExperimentalTCJiraSearchRequest {
		name: String!
		id: String!
	}

	type ExperimentalTCJiraOption {
		name: String!
		key: String!
	}

	type ExperimentalTCJiraLinks {
		jiraLinks: [ExperimentalTCJiraLink!]
	}

	type ExperimentalTCJiraLink {
		displayUrl: String!
		name: String!
		id: String!
		isSystem: Boolean
	}

	type ExperimentalTCTimezones {
		timeZones: [ExperimentalTCTimezone]
	}

	type ExperimentalTCTimezone {
		offset: String!
		name: String!
	}

	type ExperimentalBlueprint {
		blueprintModuleCompleteKey: String
		contentBlueprintId: String
		createResult: String
		description: String
		howToUseTemplate: String
		iconURL: String
		isNew: Boolean
		isPromoted: Boolean
		itemModuleCompleteKey: String
		name: String
		new: Boolean
		promoted: Boolean
		skipHowToUse: Boolean
		styleClass: String
		templateId: String
		wizard: ExperimentalBlueprintWizard
	}

	type ExperimentalBlueprintWizard {
		pages: [ExperimentalBlueprintWizardPage]
	}

	type ExperimentalBlueprintWizardPage {
		descriptionContent: String
		descriptionHeader: String
		descriptionHeaderLink: String
		id: String
		last: Boolean
		templateKey: String
		title: String
	}

	type ExperimentalEditorBreadcrumbs {
		breadcrumbs: [ExperimentalEditorBreadcrumb]
	}

	type ExperimentalEditorBreadcrumb {
		title: String
		url: String
	}

	type ExperimentalFlagResult {
		status: Boolean!
		lastSeenDate: String
	}

	input ExperimentalCaptcha {
		id: String
		response: String
	}

	input ExperimentalCommentInput {
		contentId: ID!
		commentId: ID
		requestType: String!
		html: String!
		watch: Boolean!
		uuid: String!
		captcha: ExperimentalCaptcha
	}

	input ExperimentalCommentVersion {
		number: Int
	}

	input ExperimentalFabricCommentInput {
		location: String!
		contentId: String!
		contentType: String!
		adfContent: String!
		commentId: String
		requestType: String!
		version: ExperimentalCommentVersion
	}

	input ExperimentalFabricInlineCommentInput {
		contentId: ID!
		contentType: String
		adfContent: String!
		commentId: ID
		requestType: String!
		originalSelection: String
		serializedHighlights: String
		numMatches: Int
		matchIndex: Int
		authorDisplayName: String
		authorAvatarUrl: String
		parentCommentId: ID
		lastFetchTime: String
		createdFrom: String
	}

	input ExperimentalFabricInlineReplyInput {
		parentCommentId: ID!
		contentId: ID!
		replyId: ID
		adfContent: String!
		requestType: String!
		authorDisplayName: String
		authorAccountId: String
		authorAvatarUrl: String
		hasDeletePermission: Boolean!
		hasEditPermission: Boolean!
		lastModificationDate: String
		commentDateUrl: String
	}

	type ExperimentalCommentMutationResponse {
		asyncRenderSafe: Boolean
		html: String
		id: ID
		isInlineComment: Boolean
		ownerId: ID
		parentId: ID
	}

	type ExperimentalCopyPageTreeLinksResponse {
		status: String
	}

	type ExperimentalCopyPageTreeResponse {
		id: String
		links: ExperimentalCopyPageTreeLinksResponse
	}

	type ExperimentalContainer {
		title: String
		id: ID
		status: String
		type: String
		macroRenderedOutput: ExperimentalFormattedBody
	}

	type ExperimentalExtension {
		location: String
	}

	type ExperimentalFabricComment {
		id: ID
		ancestors: [ExperimentalFabricComment]
		container: ExperimentalContainer
		extensions: ExperimentalExtension
	}

	type ExperimentalFabricInlineCommentResponse {
		result: ExperimentalFabricInlineComment
		error: ExperimentalFabricInlineCommentError
	}

	type ExperimentalFabricInlineReplyResponse {
		result: ExperimentalFabricInlineReply
		error: ExperimentalFabricInlineReplyError
	}

	type ExperimentalFabricInlineCommentResolveProperties {
		resolved: Boolean
		resolvedTime: ExperimentalLong
		resolvedByDangling: Boolean
	}

	type ExperimentalFabricInlineComment {
		id: ID!
		authorAccountId: String
		authorAvatarUrl: String!
		authorDisplayName: String!
		authorUserName: String!
		body: String
		hasDeletePermission: Boolean!
		hasEditPermission: Boolean!
		hasReplyPermission: Boolean!
		hasResolvePermission: Boolean!
		lastModificationDate: String!
		commentDateUrl: String!
		markerRef: String!
		parentCommentId: ID!
		originalSelection: String!
		resolveProperties: ExperimentalFabricInlineCommentResolveProperties
	}

	type ExperimentalFabricInlineReply {
		id: ID!
		authorAccountId: String
		authorAvatarUrl: String
		authorDisplayName: String
		authorUserName: String
		body: String
		hasDeletePermission: Boolean!
		hasEditPermission: Boolean!
		lastModificationDate: String
		commentDateUrl: String!
		commentId: ID!
	}

	type ExperimentalFabricInlineCommentError {
		errorId: String
		message: String!
	}

	type ExperimentalFabricInlineReplyError {
		errorId: String
		message: String!
	}

	type ExperimentalContentDraftDiff {
		body: String
	}

	type ExperimentalContentVersionRestored {
		restored: Boolean!
	}

	type ExperimentalDRSEligibility {
		isAdmin: Boolean
		isEligible: Boolean
	}

	type ExperimentalDRSSettings {
		cloudId: String
		success: Boolean
	}

	input ExperimentalDRSSettingsInput {
		action: String!
		domain: String
		domains: [String]
		promotionLocation: String!
	}

	type ExperimentalDesPromotionEligibility {
		domain: String!
		desPromotionEligible: Boolean!
		role: String
	}

	type ExperimentalDesSettings {
		success: Boolean
	}

	input ExperimentalDesSettingsInput {
		action: String!
		setting: String!
		domains: [String]!
		location: String!
		role: String
	}

	type ExperimentalOpenInvite {
		mode: String!
	}

	type ExperimentalOpenInviteSettings {
		success: Boolean
	}

	input ExperimentalOpenInviteSettingsInput {
		mode: String!
	}

	type ExperimentalDemoSpace {
		draftId: ID
		key: String
	}

	type ExperimentalOnboardingSpace {
		id: ID
		key: String
		name: String
		description: String
		url: String
		draftId: ID
	}

	type ExperimentalDiscoveredFeature {
		featureKey: String
		pluginKey: String
	}

	type ExperimentalExpandable {
		relationData: String
		source: String
		target: String
	}

	type ExperimentalFavouriteSpaceQuery {
		isSpaceFavourited: Boolean
	}

	type ExperimentalGenerateSpaceKey {
		key: String
	}

	type ExperimentalGrantAccess {
		responseStatus: String
		success: Boolean!
	}

	type ExperimentalGroup {
		type: String
		name: String
		links: String
		content: String
		value: String
	}

	type ExperimentalJiraIssue {
		authUrl: String
		id: ID
		key: String
		self: String
	}

	type ExperimentalKeyboardShortcutsStatus {
		enabled: Boolean
	}

	type ExperimentalLinks {
		base: String
		self: String
	}

	"""
	A simplified version of the macro's ADF node
	"""
	input ExperimentalMacroNode {
		"""
		The type of macro
		"""
		extensionKey: String!
		extensionType: String!
		"""
		The type of macro
		"""
		parameters: ExperimentalMacroParameters!
		"""
		The type of ADF node
		"""
		type: String!
	}

	type ExperimentalMacroPlaceholderResponse {
		json: String!
	}

	input ExperimentalMacroParameters {
		macroMetadata: String!
		macroParams: String!
	}

	"""
	The metadata payload for a given macro
	"""
	type ExperimentalMacroPayload {
		"""
		The metadata payload stringified
		"""
		payload: String
		contentId: String
	}

	type ExperimentalOnboardingCompletion {
		complete: Boolean
		key: String
	}

	type ExperimentalPromotedSpace {
		id: String
		text: String
	}

	type ExperimentalPromotedSpaces {
		nodes: [ExperimentalPromotedSpace]
		matchedPromotedSpaces: [ExperimentalPromotedSpace]
	}

	type ExperimentalPublishContent {
		draftUrl: String
	}

	type ExperimentalPublishContentLink {
		links: ExperimentalPublishContent
	}

	type ExperimentalCreateContentResponse {
		contentId: String
		spaceId: String
		links: ExperimentalPublishContent
		collabService: String
		subType: String
	}

	type ExperimentalUpdateContentProperty {
		success: Boolean
		id: String
		key: String
		value: String
	}

	type ExperimentalUpdateInstanceResponse {
		content: ExperimentalUpdateInstanceContent
	}

	type ExperimentalUpdateInstanceContent {
		id: String
		type: String
		subType: String
		title: String
		space: ExperimentalUpdateInstanceSpace
		_links: ExperimentalUpdateInstanceLinks
		metadata: ExperimentalUpdateInstanceMetadata
	}

	type ExperimentalUpdateInstanceSpace {
		id: String
		key: String
	}

	type ExperimentalUpdateInstanceLinks {
		editui: String
	}

	type ExperimentalUpdateInstanceMetadata {
		properties: ExperimentalUpdateInstanceMetadataProperties
	}

	type ExperimentalUpdateInstanceMetadataProperties {
		editor: ExperimentalUpdateInstanceMetadataPropertiesEditor
	}

	type ExperimentalUpdateInstanceMetadataPropertiesEditor {
		value: String
	}

	"""
	See also: CCGraphQLSchema : Long
	"""
	scalar ExperimentalLong

	"""
	See also: CCGraphQLSchema : QuickReload
	"""
	type ExperimentalQuickReload {
		time: ExperimentalLong!
		editorForPage: ExperimentalQuickReloadUser
		comments: [ExperimentalQuickReloadComment!]!
	}

	"""
	See also: CCGraphQLSchema : QuickReloadComment
	"""
	type ExperimentalQuickReloadComment {
		comment: ExperimentalQuickReloadCommentComment
	}

	"""
	See also: CCGraphQLSchema : Comment
	"""
	type ExperimentalQuickReloadCommentComment {
		id: ID!
		url: String
		author: ExperimentalQuickReloadUser!
		location: String
	}

	"""
	See also: CCGraphQLSchema : Person
	"""
	type ExperimentalQuickReloadUser {
		displayName: String
		accountId: ID
		profilePicture: String
	}

	type ExperimentalRecentContainer {
		iconUrl: String
		id: ID
		name: String
		objectId: String
		type: String
		url: String
	}

	type ExperimentalRecentContainerList {
		recentContainers: [ExperimentalRecentContainer]
	}

	type ExperimentalRelation {
		name: String
		target: String
		source: String
		relationData: String
		_expandable: ExperimentalExpandable
		_links: ExperimentalLinks
	}

	type ExperimentalRelations {
		results: [ExperimentalRelation]
		start: Int
		limit: Int
		size: Int
		context: String
		_links: ExperimentalLinks
	}

	type ExperimentalRelationsForContent {
		results: [ExperimentalRelationForContent]
	}

	type ExperimentalRelationForContent {
		source: ExperimentalKnownUser
		relationData: ExperimentalRelationDataForContent
	}

	type ExperimentalRelationDataForContent {
		friendlyCreatedDate: String
	}

	type ExperimentalRequestAccess {
		complete: Boolean!
		fullName: String
	}

	type ExperimentalSiteSignUpSettings {
		openInvite: Boolean
		selfJoinMode: String
		notifyAdmin: Boolean
		domains: [String]
		isDefault: Boolean
	}

	input ExperimentalSiteSignUpSettingsInput {
		openInvite: Boolean!
		selfJoinMode: String!
		notifyAdmin: Boolean!
		domains: [String]!
	}

	type ExperimentalOnboardingTemplate {
		templateId: String
	}

	type ExperimentalUserPersonalization {
		attributes: [ExperimentalUserPersonalizationAttributes!]
	}

	type ExperimentalUserPersonalizationAttributes {
		name: String!
		value: String!
	}

	type ExperimentalSitePersonalization {
		attributes: [ExperimentalSitePersonalizationAttributes!]
	}

	type ExperimentalSitePersonalizationAttributes {
		name: String!
		value: String!
	}

	type ExperimentalSiteUserPersonalization {
		attributes: [ExperimentalSiteUserPersonalizationAttributes!]
	}

	type ExperimentalSiteUserPersonalizationAttributes {
		name: String!
		value: String!
	}

	type ExperimentalOnboardingSpaceBlueprints {
		spaceBlueprints: [ExperimentalBlueprint]
	}

	type ExperimentalTaskMessage {
		translation: String!
		args: [String]!
	}

	type ExperimentalTaskName {
		key: String!
		args: [String]
	}

	type ExperimentalTaskLinks {
		base: String
		context: String
	}

	type ExperimentalLongTask {
		id: ID!
		name: ExperimentalTaskName
		elapsedTime: Int
		percentageComplete: Int
		successful: Boolean!
		finished: Boolean!
		_links: ExperimentalTaskLinks
		messages: [ExperimentalTaskMessage!]!
	}

	type ExperimentalSpace {
		statusCode: Int!
	}

	type ExperimentalSpaceLogo {
		key: String
		name: String
		iconPath: String
	}

	type ExperimentalSpaceSidebarQuickLink {
		id: String
		url: String
		position: String
		title: String
		styleClass: String
	}

	type ExperimentalQuickLinks {
		quickLinks: [ExperimentalSpaceSidebarQuickLink]
	}

	type ExperimentalSpaceProperty {
		key: String
		value: String
		version: ExperimentalSpacePropertyVersion
	}

	type ExperimentalSpacePropertyVersion {
		number: Int
	}

	type ExperimentalSpaceWatch {
		key: String
		watching: Boolean
	}

	type ExperimentalSuggestLabel {
		href: String
		className: String
		name: String
	}

	type ExperimentalSynchronySnapshot {
		title: String
		adf: String
	}

	type ExperimentalSynchronyJwt {
		synchronyToken: String
		configuredUrl: String
		applicationId: String
		synchronyExpiry: String
	}

	type ExperimentalUser {
		id: String
		accountId: ID
		profilePicture: ExperimentalIcon
		displayName: String
		email: String
		detailsPosition: String
		detailsDepartment: String
		detailsLocation: String
		currentUserCanFollow: Boolean
		currentUserIsFollowing: Boolean
		hasExperimentalKnownUseralSpace: Boolean
		hasBlog: Boolean
	}

	type ExperimentalUserInvitation {
		email: String
		results: ExperimentalUserInvitationResults
		userId: ID
	}

	type ExperimentalUserInvitationResults {
		conf: ExperimentalUserInvitationResult
	}

	type ExperimentalUserPermissions {
		canAddProducts: Boolean
		canInviteUsers: Boolean
	}

	type ExperimentalVersion {
		by: ExperimentalKnownUser
		collaborators: [ExperimentalKnownUser]
		confRev: String
		friendlyWhen: String
		message: String
		minorEdit: Boolean
		number: Int
		when: String
	}

	type ExperimentalFormattedBody {
		links: ExperimentalLinksContextBase
		representation: String
		value: String
		webresource: ExperimentalWebResourceDependencies
	}

	type ExperimentalHistory {
		createdBy: ExperimentalKnownUser
		createdDate: String
		lastUpdated: ExperimentalVersion
		latest: Boolean
		links: ExperimentalLinksContextSelfBase
	}

	type ExperimentalIcon {
		height: Int
		isDefault: Boolean
		path(type: ExperimentalPathType = RELATIVE_NO_CONTEXT): String!
		width: Int
	}

	type ExperimentalKnownUser {
		accountId: String
		type: String
		displayName: String
		links: ExperimentalLinksContextSelfBase
		operations: [ExperimentalOperationCheckResult]
		profilePicture: ExperimentalIcon
	}

	type ExperimentalLinksContextBase {
		base: String
		context: String
	}

	type ExperimentalLinksContextSelfBase {
		context: String
		self: String
		base: String
	}

	type ExperimentalLinksContextSelfCollectionWebuiBase {
		context: String
		self: String
		collection: String
		webui: String
		base: String
	}

	type ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase {
		base: String
		collection: String
		context: String
		download: String
		editui: String
		self: String
		tinyui: String
		webui: String
	}

	type ExperimentalOperationCheckResult {
		links: ExperimentalLinksContextBase
		operation: String
		targetType: String
	}

	enum ExperimentalPathType {
		ABSOLUTE
		RELATIVE
		RELATIVE_NO_CONTEXT
	}

	type ExperimentalSpaceOrContent {
		ancestors: [ExperimentalContent]
		body: ExperimentalContentBodyPerRepresentation
		container: ExperimentalSpaceOrContent
		history: ExperimentalHistory
		homepage: ExperimentalContent
		homepageId: ID
		icon: ExperimentalIcon
		id: ID
		key: String
	}

	input ExperimentalSpaceSidebarLink {
		title: String
		url: String
		id: ID
		resourceType: String
		resourceId: String
	}

	type ExperimentalSuperBatchWebResources {
		links: ExperimentalLinksContextBase
		metatags: String
		tags: ExperimentalWebResourceTags
		uris: ExperimentalWebResourceUris
	}

	enum ExperimentalUserInvitationResult {
		INVITED
		INVITED_PENDING_APPROVAL
		PENDING_INVITE_EXISTS
		USER_EXISTS
		PRODUCT_ADDED
		PRODUCT_EXISTS
	}

	type ExperimentalWebResourceDependencies {
		contexts: [String]
		keys: [String]
		links: ExperimentalLinksContextBase
		superbatch: ExperimentalSuperBatchWebResources
		tags: ExperimentalWebResourceTags
		uris: ExperimentalWebResourceUris
	}

	type ExperimentalWebResourceTags {
		css: String
		data: String
		js: String
	}

	type ExperimentalWebResourceUris {
		css: [String]
		data: [String]
		js: [String]
	}

	input ExperimentalSearchSessionType {
		sessionId: String!
		referrerId: String
	}

	input ExperimentalCrossProductSearchFilter {
		spaceKeys: [String]
		contributors: [String]
		date: ExperimentalCrossProductSearchFilterDate
		labels: [String]
		titleMatchOnly: Boolean
		ancestorIds: [ID]
		contentStatuses: [String]
		containerStatuses: [String]
	}

	input ExperimentalCrossProductSearchFilterDate {
		from: String
		to: String
	}

	input ExperimentalShareRequestBodyType {
		content: ExperimentalShareRequestBodyContentType!
		recipients: [ExperimentalShareRequestBodyUserOrGroupEntityList!]!
		comment: ExperimentalShareRequestBodyCommentType
		metadata: ExperimentalShareRequestBodyMetadataType!
	}

	input ExperimentalShareRequestBodyContentType {
		link: String!
		ari: String!
		title: String!
		type: String!
	}

	input ExperimentalShareRequestBodyUserOrGroupEntityList {
		id: String!
		type: String!
	}

	input ExperimentalShareRequestBodyCommentType {
		format: String!
		value: String!
	}

	input ExperimentalShareRequestBodyMetadataType {
		productId: String!
		atlOriginId: String!
		shareeAction: String
	}

	type ExperimentalCrossProductSearchResult {
		nodes: [ExperimentalCrossProductSearchResultItem]
		pageInfo: ExperimentalPageInfo
		abTest: ExperimentalAbTest
	}

	type ExperimentalCrossProductSearchResultItem {
		title: String
		url: String
		entityType: String
		excerpt: String
		lastModified: String
		content: ExperimentalCrossProductSearchResultItemContent
		space: ExperimentalCrossProductSearchResultItemSpace
	}

	type ExperimentalCrossProductSearchResultItemContent {
		id: ID
		type: String
		space: ExperimentalCrossProductSearchResultItemSpace
	}

	type ExperimentalCrossProductSearchResultItemSpace {
		id: String
		key: String
		name: String
		icon: ExperimentalIcon
		links: ExperimentalCrossProductSearchResultItemSpaceLinks
	}

	type ExperimentalCrossProductSearchResultItemSpaceLinks {
		webui: String
	}

	type ExperimentalPageInfo {
		hasNextPage: Boolean
		endCursor: String
		totalCount: Int
	}

	type ExperimentalAbTest {
		abTestId: String
		controlId: String
		experimentId: String
	}

	type ExperimentalAddCustomizedPersonalSpaceResult {
		result: Boolean
		error: String
	}

	type ExperimentalComments {
		nodes: [ExperimentalComment!]!
	}

	type ExperimentalComment {
		id: ID!
		body: String!
		author: ExperimentalUser!
		friendlyLastModified: String!
		replies: ExperimentalComments!
		location: ExperimentalInlineComment
	}

	type ExperimentalInlineComment {
		hasResolvePermission: Boolean!
		resolveProperties: ExperimentalResolveProperties!
		inlineMarkerRef: String!
		inlineText: String!
	}

	type ExperimentalResolveProperties {
		resolvedUser: String!
		resolvedFriendlyDate: String!
		resolvedByDangling: Boolean!
	}

	type ExperimentalInlineCommentReopened {
		result: Boolean!
	}

	type ExperimentalContentType {
		value: String
		label: String
	}

	type ExperimentalFavouriteSpaceType {
		spaceKey: String
	}

	type ExperimentalArchiveSpace {
		archived: Boolean!
		success: Boolean!
	}

	type ExperimentalOnboardingIntegration {
		appKey: String!
		isInstalled: Boolean!
	}

	type ExperimentalIntegrationsInstalled {
		isSlackConnected: Boolean!
		isSlackEnabled: Boolean!
		integrations: [ExperimentalOnboardingIntegration!]
	}

	type ExperimentalResetCollabServiceResponse {
		traceId: String!
	}

	type ExperimentalCancelScheduledPublishResponse {
		success: Boolean!
	}

	type ExperimentalThemeSpaceHomeOverride {
		hasSpaceHomeOverride: Boolean!
		spaceHomeOverrideDescriptor: ExperimentalConnectIFrame
	}

	type ExperimentalConnectIFrame {
		addon_key: String
		apiMigrations: ExperimentalThemeAPIMigrations
		contentClassifier: String
		contextJwt: String
		cp: String
		general: String
		h: String
		hostOrigin: String
		key: String
		moduleType: String
		origin: String
		productCtx: String
		sandbox: String
		structuredContext: String
		timeZone: String
		uniqueKey: String
		url: String
		w: String
	}

	type ExperimentalThemeAPIMigrations {
		gdpr: Boolean
	}

	type ExperimentalConnectServletResponse {
		url: String
	}

	type ExperimentalNotificationsResponse {
		cursor: String!
		nodes: [ExperimentalNotification!]!
	}

	type ExperimentalNotification {
		id: ID!
		readState: ExperimentalNotificationReadState!
		timestamp: String!
		content: ExperimentalNotificationContent!
		message: String!
		path: [ExperimentalNotificationPathNode!]!
	}

	enum ExperimentalNotificationReadState {
		UNREAD
		READ
	}

	type ExperimentalNotificationContent {
		title: String!
		actor: ExperimentalNotificationActor!
		body: ExperimentalNotificationBody
		iconUrl: String!
		link: String!
	}

	type ExperimentalNotificationActor {
		id: ID!
		avatarUrl: String!
		displayName: String!
	}

	type ExperimentalNotificationPathNode {
		title: String!
		iconUrl: String
		link: String
	}

	type ExperimentalNotificationBody {
		data: String!
		format: String!
	}

	type ExperimentalConnectContext {
		hasResponse: Boolean!
		connectDescriptor: ExperimentalConnectIFrame
	}

	enum ExperimentalHeartbeatUserType {
		EDIT
		VIEW
	}

	type ExperimentalHeartbeatUser {
		accountId: String!
		heartbeatUserType: ExperimentalHeartbeatUserType!
	}

	type ExperimentalEditorHeartbeatResponse {
		orderedUsers: [ExperimentalHeartbeatUser!]
		editorSessionId: String
		status: String
		message: String
		error: String
	}

	type ExperimentalConnectModule {
		modules: JSON
	}

	type ExperimentalCustomContentPageResponse {
		start: Int
		limit: Int
		size: Int
		_links: ExperimentalLinksContextSelfBase
		results: [ExperimentalCustomContentPageResponseResult]
	}

	type ExperimentalCustomContentPageResponseResult {
		id: ID
		status: String
		title: String
		macroRenderedOutput: ExperimentalFormattedBody
		type: String
		_links: ExperimentalLinksContextSelfCollectionWebuiBase
		_expandable: ExperimentalCustomContentExpandable
	}

	type ExperimentalCustomContentExpandable {
		ancestors: String
		body: String
		children: String
		childTypes: String
		container: String
		descendants: String
		history: String
		metadata: String
		operations: String
		restrictions: String
		schedulePublishDate: String
		space: String
		version: String
	}

	type ExperimentalCustomContentPropertiesResponse {
		id: ID
		type: String
		status: String
		title: String
		history: ExperimentalContentHistory
		metadata: ExperimentalContentMetadata
		operations: [ExperimentalContentOperations]
		_links: ExperimentalLinksContextSelfCollectionWebuiBase
	}

	type ExperimentalContentOperations {
		operation: String
		targetType: String
	}
	type ExperimentalContentHistory {
		latest: Boolean
		createdDate: String
		createdBy: ExperimentalContentHistoryUser
	}

	type ExperimentalContentHistoryUser {
		type: String
		accountId: String
		accountType: String
		email: String
		publicName: String
		timeZone: String
		displayName: String
		profilePicture: ExperimentalIcon
	}

	type ExperimentalContentMetadata {
		# not a typo. not label[]
		labels: ExperimentalContentMetadataLabels
	}

	type ExperimentalContentMetadataLabels {
		start: Int
		size: Int
		limit: Int
		results: [ExperimentalContentMetadataLabelResult]
	}

	type ExperimentalContentMetadataLabelResult {
		id: String
		label: String
		prefix: String
		name: String
	}

	type ExperimentalCustomContentPropertiesPageResponse {
		status: String
		results: [ExperimentalCustomContentPropertiesResponse]
	}

	type ExperimentalShareResponse {
		success: Boolean!
		status: String
	}

	type ExperimentalUnlicensedPermissionResponse {
		unlicensedPermissionId: ExperimentalLong
	}

	type ExperimentalRemoveUnlicensedPermissionResponse {
		success: Boolean!
	}

	type ExperimentalAnalyticsSpaceLevelActivity {
		id: String
		key: String
		type: String
		name: String
		webui: String
		iconUrl: String
		created: Int
		updated: Int
		views: Int
		usersViewed: Int
		lastViewedAt: String
	}

	type ExperimentalAnalyticsPagination {
		next: String
		previous: String
	}

	type ExperimentalAnalyticsActivityByDateDateLevelActivity {
		date: String
		total: Int
	}

	type ExperimentalAnalyticsActivityByDateActivity {
		creates: [ExperimentalAnalyticsActivityByDateDateLevelActivity]
		searches: [ExperimentalAnalyticsActivityByDateDateLevelActivity]
		updates: [ExperimentalAnalyticsActivityByDateDateLevelActivity]
		views: [ExperimentalAnalyticsActivityByDateDateLevelActivity]
	}

	type ExperimentalAnalyticsActivityByDateResponse {
		activityByDate: ExperimentalAnalyticsActivityByDateActivity
	}

	type ExperimentalAnalyticsUniqueSearchTermCountResponse {
		count: Int
	}

	type ExperimentalAnalyticsSearchCountGroupByPageItem {
		page: String
		count: Int
	}

	type ExperimentalAnalyticsSearchCountGroupByPageResponse {
		data: [ExperimentalAnalyticsSearchCountGroupByPageItem]
		pageInfo: ExperimentalAnalyticsPaginationInfo
	}

	type ExperimentalAnalyticsSearchCountGroupBySpaceItem {
		space: String
		count: Int
	}

	type ExperimentalAnalyticsSearchCountGroupBySpaceResponse {
		data: [ExperimentalAnalyticsSearchCountGroupBySpaceItem]
		pageInfo: ExperimentalAnalyticsPaginationInfo
	}

	type ExperimentalAnalyticsSearchTimeseriesCTRItem {
		ctr: String
		timestamp: String
	}

	type ExperimentalAnalyticsSearchTimeseriesCTRResponse {
		data: [ExperimentalAnalyticsSearchTimeseriesCTRItem]
	}

	type ExperimentalAnalyticsSearchTimeseriesCountItem {
		count: Int
		timestamp: String
	}

	type ExperimentalAnalyticsSearchTimeseriesCountResponse {
		data: [ExperimentalAnalyticsSearchTimeseriesCountItem]
	}

	type ExperimentalAnalyticsActivityBySpaceResponse {
		activityBySpace: [ExperimentalAnalyticsSpaceLevelActivity]
		paginationInfo: ExperimentalAnalyticsPagination
	}

	type ExperimentalAnalyticsViewsByCurrentUserResponse {
		viewsByUser: [ExperimentalAnalyticsViewsByCurrentUser]
	}

	type ExperimentalAnalyticsViewsByCurrentUser {
		accountId: String
		lastVersionViewed: Int
		lastVersionViewedUrl: String
		lastViewedAt: String
		mostRecentViewModificationDate: ExperimentalLong
		userId: String
		views: Int
	}

	type ExperimentalAnalyticsViewsByDate {
		date: String
		total: Int
	}

	type ExperimentalAnalyticsContentViews {
		contentId: String
		createdAt: String
		lastModificationDate: String
		lastViewedAt: String
		title: String
		totalComments: Int
		totalViewed: Int
		type: String
		uniqueUsersViewed: Int
		webui: String
	}

	type ExperimentalAnalyticsActivityByUser {
		accountId: String
		commentCreated: Int
		created: Int
		updated: Int
		viewed: Int
		searchPerformed: Int
	}

	type ExperimentalAnalyticsPaginationInfo {
		next: String
		prev: String
	}

	type ExperimentalAnalyticsViewsByDateResponse {
		viewsByDate: [ExperimentalAnalyticsViewsByDate]
	}

	type ExperimentalAnalyticsContentViewsResponse {
		contentViews: [ExperimentalAnalyticsContentViews]
		paginationInfo: ExperimentalAnalyticsPaginationInfo
	}

	type ExperimentalAnalyticsActivityByUserResponse {
		activityByUser: [ExperimentalAnalyticsActivityByUser]
		paginationInfo: ExperimentalAnalyticsPaginationInfo
	}

	input ExperimentalAnalyticsRestrictionsUserGroupInput {
		accountId: String
		userId: String
		displayName: String
		profilePictureUrl: String
		email: String
		groupId: String
		groupName: String
		useAnalytics: Boolean
	}

	input ExperimentalAnalyticsRestrictionsGroupInput {
		profilePictureUrl: String
		groupId: String!
		groupName: String!
		useAnalytics: Boolean!
	}

	type ExperimentalAnalyticsRestrictionsUserGroup {
		accountId: String
		userId: String
		displayName: String
		profilePictureUrl: String
		email: String
		groupId: String
		groupName: String
		useAnalytics: Boolean
	}

	type ExperimentalAnalyticsRestrictionsGroup {
		profilePictureUrl: String
		groupId: String!
		groupName: String!
		useAnalytics: Boolean!
	}

	type ExperimentalAnalyticsRestrictionsBySpaceResponse {
		restrictions: [ExperimentalAnalyticsRestrictionsUserGroup]
	}

	type ExperimentalAnalyticsSetRestrictionsBySpaceResponse {
		restrictions: [ExperimentalAnalyticsRestrictionsUserGroup]
	}

	type ExperimentalAnalyticsSetSiteRestrictionsResponse {
		restrictions: [ExperimentalAnalyticsRestrictionsGroup]
	}

	type ExperimentalSpaceContentViewExportResponse {
		jobId: String!
		createdAt: String!
	}

	type ExperimentalExportMediaLink {
		clientId: String!
		mediaFileId: String!
		fileName: String!
		token: String!
		mediaBaseUrl: String!
	}

	type ExperimentalExportStatusResponse {
		id: String!
		state: String!
		mediaLink: ExperimentalExportMediaLink
	}

	type ExperimentalCreateAutomationRuleFromTemplateResponse {
		ruleId: ID
	}

	type ExperimentalAutomationRuleConnectionsResponse {
		id: String!
		connectionTargetKey: String!
		accountId: String!
		targetConfigJson: ExperimentalConnectionTargetConfig
		container: ExperimentalConnectionContainer
		createdAt: String!
		updatedAt: String!
	}

	type ExperimentalConnectionTargetConfig {
		cloudId: String!
		baseUrl: String!
	}

	type ExperimentalConnectionContainer {
		id: String!
		type: String!
	}

	type ExperimentalAutomationRuleSummaryResponse {
		id: String!
		name: String!
		authorAccountId: ID!
		ruleState: ExperimentalAutomationRuleState!
		componentSummaries: [ExperimentalAutomationComponentConfigSummary!]!
	}

	enum ExperimentalAutomationRuleState {
		NEW
		ENABLED
		DISABLED
	}

	type ExperimentalAutomationComponentConfigSummary {
		componentName: String!
		component: String!
		type: String!
		childComponentSummaries: [ExperimentalAutomationComponentConfigSummary!]!
	}

	enum TemplateParameterTypeEnum {
		TEXT
		NUMBER
		BOOLEAN
	}

	input ExperimentalCreateAutomationRuleFromTemplateParameter {
		name: String!
		type: TemplateParameterTypeEnum!
		value: String!
	}

	enum ExperimentalAutomationActorConfigType {
		ACCOUNT_ID
		EVENT_INITIATOR
		SMART_VALUE
	}

	type ExperimentalAutomationActor {
		type: ExperimentalAutomationActorConfigType
		value: String
	}

	type ExperimentalAutomationComponent {
		id: ID
		component: String
		parentId: ID
		conditionParentId: ID
		schemaVersion: Int
		type: String
		value: JSON
		children: [JSON]
		conditions: [JSON]
		connectionId: ID
	}

	enum ExperimentalTagType {
		WEBHOOK_TOKEN
		POLLING
		SERVICE_LIMIT_BREACHED
		USES_DEVOPS_INTEGRATION
		TEMPLATE_ID
		CREATION_TYPE
		BILLABLE
		IS_RULE_UPDATED
		SAMPLE_RULE_INTENT
		SAMPLE_RULE
	}

	type ExperimentalAutomationRuleTag {
		id: ID
		tagType: ExperimentalTagType
		tagValue: String
	}

	enum ExperimentalNotifyOnError {
		FIRSTERROR
		EVERYERROR
		NEVER
	}

	type ExperimentalRuleHomeLifecycle {
		locationARI: String
	}

	type ExperimentalRuleHomeBilling {
		locationARI: String
	}

	type ExperimentalAutomationRuleScope {
		resources: [String]
	}

	type ExperimentalAutomationRuleHome {
		ruleLifecycleHome: ExperimentalRuleHomeLifecycle
		ruleBillingHome: ExperimentalRuleHomeBilling
	}

	enum ExperimentalAutomationWriteAccessType {
		OWNER_ONLY
		UNRESTRICTED
		SPECIFIED_USERS
	}

	enum ExperimentalAutomationBillingType {
		NORMAL
		SYSTEM
	}

	type ExperimentalGetAutomationRuleByIdResponse {
		id: ID
		clientKey: String
		name: String
		state: ExperimentalAutomationRuleState
		description: String
		authorAccountId: ID
		actor: ExperimentalAutomationActor
		created: ExperimentalLong
		updated: ExperimentalLong
		trigger: ExperimentalAutomationComponent
		components: [ExperimentalAutomationComponent]
		canOtherRuleTrigger: Boolean
		notifyOnError: String
		projects: [JSON]
		labels: [JSON]
		tags: [ExperimentalAutomationRuleTag]
		ruleScope: ExperimentalAutomationRuleScope
		ruleHome: ExperimentalAutomationRuleHome
		writeAccessType: ExperimentalAutomationWriteAccessType
		collaborators: [JSON]
		billingType: ExperimentalAutomationBillingType
	}

	input ExperimentalAutomationUpdateRuleActor {
		type: ExperimentalAutomationActorConfigType!
		value: String
	}

	input ExperimentalAutomationUpdateRuleComponent {
		id: ID!
		component: String!
		parentId: ID
		conditionParentId: ID
		schemaVersion: Int
		type: String!
		value: JSON!
		children: [JSON]!
		conditions: [JSON]!
		connectionId: ID
	}

	input ExperimentalAutomationUpdateRuleTag {
		id: ID
		tagType: ExperimentalTagType!
		tagValue: String
	}

	input ExperimentalAutomationUpdateRuleScope {
		resources: [String]!
	}

	input ExperimentalAutomationUpdateRuleHomeLifecycle {
		locationARI: String!
	}

	input ExperimentalAutomationUpdateRuleHomeBilling {
		locationARI: String!
	}

	input ExperimentalAutomationUpdateRuleHome {
		ruleLifecycleHome: ExperimentalAutomationUpdateRuleHomeLifecycle!
		ruleBillingHome: ExperimentalAutomationUpdateRuleHomeBilling!
	}

	input ExperimentalUpdateAutomationRuleConfigBean {
		actor: ExperimentalAutomationUpdateRuleActor!
		authorAccountId: ID
		billingType: ExperimentalAutomationBillingType!
		canOtherRuleTrigger: Boolean!
		clientKey: String!
		collaborators: [JSON]!
		components: [ExperimentalAutomationUpdateRuleComponent]!
		created: ExperimentalLong!
		description: String!
		id: ExperimentalLong!
		labels: [JSON]!
		name: String!
		notifyOnError: String!
		projects: [JSON]!
		ruleHome: ExperimentalAutomationUpdateRuleHome!
		ruleScope: ExperimentalAutomationUpdateRuleScope!
		state: ExperimentalAutomationRuleState!
		tags: [ExperimentalAutomationUpdateRuleTag]!
		trigger: ExperimentalAutomationUpdateRuleComponent!
		updated: ExperimentalLong!
		writeAccessType: ExperimentalAutomationWriteAccessType!
	}

	type ExperimentalUpdateAutomationRuleResponse {
		id: ExperimentalLong!
		state: ExperimentalAutomationRuleState!
	}
`;

// re-exporting this as default for the sake of "@graphql-codegen/cli"
// eslint-disable-next-line import/no-default-export
export default ExperimentalSchema;
